import React from 'react'
import { AppAlignment } from '../../HomePageMain/Navbar/Navbarcss'
import { FeaturesData } from './FeaturesData'

const Features = () => {
  return (
    <AppAlignment>
      <FeaturesData />
    </AppAlignment>
  );
};

export { Features };
